import { MutationHookOptions, useMutation } from '@apollo/client';

import { UPDATE_BRIEF_FISCAL_PERIOD } from '../queries/UpdateBriefsFiscalPeriodMutation';
import {
  UpdateBriefsFiscalPeriodMutation,
  UpdateBriefsFiscalPeriodMutationVariables,
} from '../queries/types/UpdateBriefsFiscalPeriodMutation';

type IOptions = MutationHookOptions<UpdateBriefsFiscalPeriodMutation, UpdateBriefsFiscalPeriodMutationVariables>;

export const useUpdateBriefsFiscalPeriodMutation = (options: IOptions = {}) =>
  useMutation<UpdateBriefsFiscalPeriodMutation>(UPDATE_BRIEF_FISCAL_PERIOD, options);

export type TUseUpdateBriefsFiscalPeriodMutation = ReturnType<typeof useUpdateBriefsFiscalPeriodMutation>;
